import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  Button, Text, Flex
} from '@chakra-ui/react'

interface ExitModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ExitModal({ isOpen, onClose, onConfirm }: ExitModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#09090b" color="white" textAlign="center">
        <ModalHeader textAlign="center">Exit Match</ModalHeader>
        <ModalBody textAlign="center">
          <Text>Are you sure?</Text>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Flex gap={3} justify="center" w="100%">
            <Button 
              variant="outline" 
              colorScheme="gray" 
              onClick={onClose} 
              bg="white" 
              color="gray.700"
              flex={1}
              maxW="120px"
            >
              Cancel
            </Button>
            <Button 
              bg="#dd0000"
              color="white"
              onClick={onConfirm}
              flex={1}
              maxW="120px"
              _hover={{ bg: "#b80000" }}
            >
              Exit
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
} 